import {
    SAVE_DOMAIN_GROUP_REQUEST,
    SAVE_DOMAIN_GROUP_SUCCESS,
    SAVE_DOMAIN_GROUP_FAILURE,
    FETCH_DOMAIN_GROUPS_REQUEST,
    FETCH_DOMAIN_GROUPS_SUCCESS,
    FETCH_DOMAIN_GROUPS_FAILURE,
    DELETE_DOMAIN_GROUP_SUCCESS,
    DELETE_DOMAIN_GROUP_REQUEST,
    DELETE_DOMAIN_GROUP_ERROR,
    CREATE_DOMAIN_GROUP,
    RENAME_SELECTED_DOMAIN_GROUP,
    SELECT_DOMAIN_GROUP,
    UPDATE_DOMAINS_IN_SELECTED_GROUP,
    DISMISS_DOMAIN_GROUPING_FORM,
} from '../actions/types/domain-groups-action-types';
import { omit, filter } from 'lodash';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_DOMAIN_GROUPS_REQUEST:
        case DELETE_DOMAIN_GROUP_REQUEST:
            newState = true;
            break;
        case FETCH_DOMAIN_GROUPS_SUCCESS:
        case FETCH_DOMAIN_GROUPS_FAILURE:
        case DELETE_DOMAIN_GROUP_SUCCESS:
        case DELETE_DOMAIN_GROUP_ERROR:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function isUpdating( state = false, action ){
    let newState;
    switch( action.type ){
        case SAVE_DOMAIN_GROUP_REQUEST:
            newState = true;
            break;
        case SAVE_DOMAIN_GROUP_FAILURE:
        case SAVE_DOMAIN_GROUP_SUCCESS:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}
function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case SAVE_DOMAIN_GROUP_SUCCESS:
            newState = { ...state, ...action.domainGroupsById };
            break;
        case FETCH_DOMAIN_GROUPS_SUCCESS:
            newState = { ...action.domainGroupsById };
            break;
        case FETCH_DOMAIN_GROUPS_REQUEST:
        case FETCH_DOMAIN_GROUPS_FAILURE:
            newState = {};
            break;
        case DELETE_DOMAIN_GROUP_SUCCESS:
            newState = omit( state, [action.id] );
            break;
        default:
            return state;
    }

    return newState;
}

function allIds( state = [], action ){
    let newState;
    switch( action.type ){
        case SAVE_DOMAIN_GROUP_SUCCESS:
            newState = [...new Set( state.concat( action.allIds ) )];
            break;
        case FETCH_DOMAIN_GROUPS_SUCCESS:
            newState = action.allDomainGroupIds;
            break;
        case FETCH_DOMAIN_GROUPS_REQUEST:
        case FETCH_DOMAIN_GROUPS_FAILURE:
            newState = [];
            break;
        case DELETE_DOMAIN_GROUP_SUCCESS:
            newState = filter( state, ( id ) =>  id !== action.id );
            break;
        default:
            return state;
    }

    return newState;
}

// *** Domain Grouping Form Reducers ***
// These Reducers manipulate and maintain the 
// "dirty" domain grouping form state
function selectedDomainGroupId( state = null, { type, id = null } ){
    let newState;
    switch( type ){
        case CREATE_DOMAIN_GROUP:
            newState = null;
            break;
        case SELECT_DOMAIN_GROUP:
            newState = id;
            break;
        default:
            return state;
    }

    return newState;
}

function selectedDomainGroupName( state = null, action ){
    let newState;
    switch( action.type ){
        case CREATE_DOMAIN_GROUP:
        case RENAME_SELECTED_DOMAIN_GROUP:
        case SELECT_DOMAIN_GROUP:
            newState = action.name;
            break;
        default:
            return state;
    }

    return newState;
}

function selectedDomainGroupDescription( state = null, { description = '', type } ){
    let newState;
    switch( type ){
        case CREATE_DOMAIN_GROUP:
            newState = description;
            break;
        case SELECT_DOMAIN_GROUP:
            newState = description;
            break;
        default:
            return state;
    }

    return newState;
}

function selectedDomainGroupDomainList( state = [], action ){
    let newState;
    switch( action.type ){
        case SELECT_DOMAIN_GROUP:
        case UPDATE_DOMAINS_IN_SELECTED_GROUP:
            newState = [...action.domains] || [];
            break;
        default:
            return state;
    }

    return newState;
}

function isDirty( state = false, action ){
    let newState;
    switch( action.type ){
        case RENAME_SELECTED_DOMAIN_GROUP:
        case UPDATE_DOMAINS_IN_SELECTED_GROUP:
            newState = true;
            break;
        default:
            return state;
    }

    return newState;
}

const formState = combineReducers( {
    description: selectedDomainGroupDescription,
    domains: selectedDomainGroupDomainList,
    id: selectedDomainGroupId,
    isDirty,
    name: selectedDomainGroupName,
} );

const domainGroupingRootReducer = combineReducers( {
    allIds,
    byId,
    formState,
    isLoading,
    isUpdating
} );

export default function rootWrapper( state, action ){
    if( action.type === SAVE_DOMAIN_GROUP_SUCCESS ||
        action.type === DISMISS_DOMAIN_GROUPING_FORM
    ){
        return domainGroupingRootReducer( { ...state, formState: undefined }, action );
    }
    else{
        return domainGroupingRootReducer( state, action );
    }

};
